import { LanguageCode } from '../i18n';
import { Theme } from '../theme';

export interface BaseUserPreferences {
	/**
	 * App language.
	 */
	language: LanguageCode;

	/**
	 * App theme.
	 */
	theme: Theme;

	/*
	 * Enable sending diagnostics and usage information
	 */
	diagnostics: boolean;

	/*
	 * Enable sending crash log file
	 */
	crashReport: boolean;

	/**
	 * Selected interfaceId for sysapi
	 */
	networkInterfaceId: string;

	/**
	 * Recent file system path for file and folder dialogs
	 */
	recentFileSystemPath: string;
}

export enum AnalyticsCrashReportOptIn {
	IN = 'IN',
	OUT = 'OUT'
}
